import { FormAccordion } from '@strata/react-form-section';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { ReferralChecklistSection } from 'components/referrals/ReferralChecklistSection';
import { FormSections } from 'store/checklist/referralChecklistSchema';
import { closeSection, openSection } from 'store/checklist/referralChecklistSlice';

const FormSectionTitleMap = {
    [FormSections.REFERRAL_SUBMITTED_TO_PAYER]: 'Referral Submitted to FMH',
    [FormSections.REFERRAL_OPPORTUNITY_FOUND]: 'Referral Opportunity Found',
    [FormSections.REFERRAL_REFERENCE_ENRICHED]: 'Referral Reference Enriched',
    [FormSections.REFERRAL_WRITTEN]: 'Referral Written to Client DB',
    [FormSections.AUCTION_MEMBER_INFO_ENRICHED]: 'Auction Member Info Enriched',
    [FormSections.AUCTION_REFERENCE_ENRICHED]: 'Auction Reference Enriched',
    [FormSections.AUCTION_WRITTEN]: 'Auction Written',
    [FormSections.AUCTION_ENDED]: 'Auction Ended',
    [FormSections.SERVICING_SUPPLIER_FAX_SENT]: 'Servicing Supplier Fax Sent',
};

export const ReferralChecklist = ({ referralId = undefined }) => {
    const dispatch = useDispatch();
    const { sections } = useSelector((state) => state.referralChecklist);

    const referralEvents = useSelector((state) => state.referrals.referralEvents[referralId]);
    const indicatorStatuses = {};

    // Populate the indicator statuses for all the sections.
    if (referralEvents) {
        Object.keys(FormSections).forEach((section) => {
            if (section in referralEvents) {
                indicatorStatuses[section] = FormAccordion.statuses.COMPLETED;
            } else {
                indicatorStatuses[section] = FormAccordion.statuses.NOT_STARTED;
            }
        });
    }

    const intakeFormSections = Object.keys(FormSections).map((sectionKey) => {
        const section = FormSections[sectionKey];
        return {
            sectionTitle: FormSectionTitleMap[section],
            content: <ReferralChecklistSection section={sectionKey} referralId={referralId} />,
            step: section,
            progressIndicatorStatus: indicatorStatuses[sectionKey],
            onSectionClick: () =>
                dispatch(!sections[section].isOpen ? openSection(section) : closeSection(section)),
            disabled: false,
            isOpen: sections[section].isOpen,
            displayFooter: false,
            scrollToTopOnOpen: true,
            scrollOffset: 44,
        };
    });

    return <FormAccordion sectionDataArray={intakeFormSections} />;
};

ReferralChecklist.propTypes = {
    referralId: PropTypes.string,
};
